import Vue from 'vue'
import Router from 'vue-router' // 文档地址 https://router.vuejs.org/zh/
import { isPc } from '@/utils/platform'

Vue.use(Router)

const routerInstance = new Router({
  mode: 'history',
  routes: [
    {
      path: '/', // 登录页
      name: 'index',
      component: () => import('@/views/login'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/login', // 登录页
      name: 'login',
      component: () => import('@/views/login'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/activityDetail', // 活动详情
      name: 'detail',
      component: () => import('@/views/detal/detal')
    },
    {
      path: '/detail', // 活动详情
      name: 'detail',
      component: () => import('@/views/detal/detal')
    }
  ]
})


routerInstance.beforeEach((to, from, next) => {
  if (isPc() && to.name === 'detail') {
    location.href = `${process.env.VUE_APP_MAIN_URL}/activityDetail?id=${to.query.id}`
  } else if (!isPc() && to.name === 'detail') {
    location.href = `${process.env.VUE_APP_WX_URL}/activityDetail?id=${to.query.id}`
  }
  next()
})

export default routerInstance
